// eslint-disable-next-line import/no-extraneous-dependencies
import request from '../../client';
import { DrupalGuaranteeItems } from '../../utils/cart/types';
import { CartInStore } from '../../slices/cart/types';

/**
 * Fetch the user active cart.
 *
 * Resolves to null when the user has no active cart at all: the service
 * answers an empty 204 for that case. An existing cart with no line items
 * still comes back as a full cart object.
 */
const getActiveCart = (): Promise<CartInStore | null> =>
  request({
    uri: 'carts/active-cart',
    options: {
      method: 'GET',
      headers: {
        'Cache-Control': 'private, max-age=0, no-cache, no-store',
        Expires: 0,
      },
    },
  }) as Promise<CartInStore | null>;

/**
 * Fetch guarantee items from Drupal given a filter query string.
 *
 * @todo This method could be used for other API calls.
 */
const getGuaranteeItems = (
  filterQueryString: string,
): Promise<DrupalGuaranteeItems> =>
  request({
    host: window.location.origin,
    uri: `hHoZuU7e/jsonapi/node/product_display?${filterQueryString}`,
    options: {
      method: 'GET',
    },
    authToken: false,
  }) as Promise<DrupalGuaranteeItems>;

const addPromoCode = ({
  promoCode,
  cartId,
}: {
  promoCode: string;
  cartId: string;
}): Promise<void> =>
  request({
    uri: 'carts/code',
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code: promoCode, cartId }),
    },
  }) as Promise<void>;

const removePromoCode = ({
  promoCode,
  cartId,
}: {
  promoCode: string;
  cartId: string;
}): Promise<void> =>
  request({
    uri: `carts/code/${promoCode}`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ cartId }),
    },
  }) as Promise<void>;

const getTaxEstimation = (zipCode: string) =>
  request({
    uri: `carts/active-cart/tax-estimation?zipCode=${zipCode}`,
    options: {
      method: 'GET',
    },
  }) as Promise<{ centAmount: number }>;

export {
  getActiveCart,
  getGuaranteeItems,
  addPromoCode,
  removePromoCode,
  getTaxEstimation,
};
